import React from 'react';
import { useLocalStorage } from 'react-use';
import { LabelValue } from '../../../../platform/types/LabelValue';
import { Url } from '../../../../platform/Url';
import { AccountModel } from '../../../account/AccountModel';
import { useLocationScope } from '../../../AppLocation';
import { useResolve } from '../../../Container';
import { ManageFrame } from '../ManageFrame';
import { PeopleInvitesListView } from './PeopleInvitesListView';
import { PeopleMembersListView } from './PeopleMembersListView';

const viewOptions = [
    LabelValue('Members', 'members'),
    LabelValue('Invites', 'invites'),
];

export type TabProps = {
    viewOptions: LabelValue<string>[],
    view: string,
    setView: (view: string) => void,
};

export const ManagePeopleView = () => {

    const { plan } = useResolve(AccountModel);
    const hasFeature = !!plan.features.inviteApprovals;

    useLocationScope('people', 'overview');

    const savedView = Url.consumeParam('view');
    if (savedView) {
        localStorage.setItem('deqo/ui/admin/people/view', savedView);
    }

    const defaultView = hasFeature ? (savedView ?? 'members') : 'members';

    const [view, setView] = useLocalStorage('deqo/ui/admin/people/view', defaultView);

    return <ManageFrame title="People">
        {view === 'members' && <PeopleMembersListView viewOptions={viewOptions} view={view} setView={setView} hasFeature={hasFeature} />}
        {view === 'invites' && <PeopleInvitesListView viewOptions={viewOptions} view={view} setView={setView} />}
    </ManageFrame>;
};
